import React, { useState } from "react";
import { Button, TextField, Box, Typography, Grid } from "@mui/material";
import { takrarPranaliForm } from "../utils/axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AttachmentIcon from '@mui/icons-material/Attachment';
import TopBarStatic from "./TopBarStatic";

const TakararPranaliForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    taluka_id: 1,
    mobile_no: "",
    takrar: "",
    attachment_file: null,
  });

  const [errors, setErrors] = useState({});

  // Handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // Handle file upload
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setFormData((prev) => ({ ...prev, attachment_file: file }));
  };

  // Validate form
  const validate = () => {
    let tempErrors = {};

    if (!formData.name) tempErrors.name = "Name is required";
    if (!formData.mobile_no) {
      tempErrors.mobile_no = "Mobile number is required";
    } else if (!/^[0-9]{10}$/.test(formData.mobile_no)) {
      tempErrors.mobile_no = "Invalid mobile number";
    }
    if (!formData.email) {
      tempErrors.email = "Email is required";
    } else if (!/^[\w-\\.]+@([\w-]+\.)+[\w-]{2,4}$/.test(formData.email)) {
      tempErrors.email = "Invalid email format";
    }

    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (validate()) {
      try {
        const formDataToSend = new FormData();
        formDataToSend.append("name", formData.name);
        formDataToSend.append("email", formData.email);
        formDataToSend.append("taluka_id", formData.taluka_id);
        formDataToSend.append("mobile_no", formData.mobile_no);
        formDataToSend.append("takrar", formData.takrar);

        if (formData.attachment_file instanceof File) {
          formDataToSend.append("attachment_file", formData.attachment_file);
        }

        const response = await takrarPranaliForm(formDataToSend);

        toast.success("Form submitted successfully!");

        // ✅ Reset form state after submission
        setFormData({
          name: "",
          email: "",
          taluka_id: 1,
          mobile_no: "",
          takrar: "",
          attachment_file: null,
        });

        setErrors({});
      } catch (error) {
        console.error("Submission Error:", error);
        if (error.response) {
          toast.error(error.response.data.message || "Submission failed");
        } else {
          toast.error("An error occurred while submitting the form.");
        }
      }
    }
  };

  return (
    <Box className="ff_baloo" sx={{ width: "90%", marginLeft: "6.5%", marginTop: "6.5%" }}>
      <TopBarStatic />
      <Box
        sx={{
          maxWidth: 500,
          mx: "auto",
          mt: 4,
          p: 3,
          boxShadow: 1,
          borderRadius: 2,
          bgcolor: "#fff",
        }}
      >
        <ToastContainer position="top-right" autoClose={3000} />
        <Typography
          variant="h6"
          align="center"
          className="ff_yatra"
          sx={{ fontSize: "35px", padding: "10px" }}
        >
          तक्रार प्रणाली
        </Typography>
        <form onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            {/* Name */}
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                error={Boolean(errors.name)}
                helperText={errors.name}
              />
            </Grid>

            {/* Mobile */}
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Mobile"
                name="mobile_no"
                value={formData.mobile_no}
                onChange={handleChange}
                error={Boolean(errors.mobile_no)}
                helperText={errors.mobile_no}
              />
            </Grid>

            {/* Email */}
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                error={Boolean(errors.email)}
                helperText={errors.email}
              />
            </Grid>

            {/* Takrar */}
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Takrar"
                name="takrar"
                multiline
                rows={4}
                value={formData.takrar}
                onChange={handleChange}
                error={Boolean(errors.takrar)}
                helperText={errors.takrar}
              />
            </Grid>

            {/* File Upload */}
            <Grid item xs={12}>
              <Button
                variant="outlined"
                component="label"
                fullWidth
                sx={{
                  textTransform: "none",
                  borderColor: "rgba(0, 0, 0, 0.23)",
                }}
              >
                Upload Attachment <AttachmentIcon sx={{ ml: "10px" }} />
                <input type="file" hidden onChange={handleFileChange} />
              </Button>
              {formData.attachment_file && (
                <Typography mt={1} variant="body2" color="text.secondary">
                  {formData.attachment_file.name}
                </Typography>
              )}
            </Grid>

            {/* Submit Button */}
            <Grid item xs={12}>
              <Button
                type="submit"
                variant="contained"
                fullWidth
                sx={{
                  bgcolor: "#4caf50",
                  color: "#fff",
                  "&:hover": { bgcolor: "#45a049" },
                  mt: 2,
                }}
              >
                Submit
              </Button>
            </Grid>
          </Grid>
        </form>
      </Box>
    </Box>
  );
};

export default TakararPranaliForm;
